import React, { useState } from "react";
import LmsActionInput from "../ui/LmsActionInput";
import LmsTable from "../ui/LmsTable";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { BCFormController } from "../ui/LmsFormGenerator";

const LmsAccountingUnFundedDraws = () => {
  const [changeReason, setChangeReason] = useState("");
  const actionButtons = [
    "export",
    "save",
    "cancel",
    {
      action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
      text: "Move to Draws in Process",
      submitSuffix: "draws/initiate-draws-in-process",
      isDisabled: (checkedItems) => checkedItems?.length < 1,
      icon: GlobalConstants.Icons.CARET_UP,
    },
    {
      action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
      text: "Move to Requested",
      submitSuffix: "draws/decline-draws",
      method: "PUT",
      isDisabled: (checkedItems) => checkedItems?.length !== 1,
      onSuccessFunc: () => setChangeReason(""),
      refreshDataOnSuccess: true,
      icon: GlobalConstants.Icons.CARET_UP,
      alertMessage: !changeReason ? "Please add the reason" : undefined,
      confirmationMessage: "Are you sure you want to change the status to Requested for the selected record(s)?",
      handleFormatSubmitSelectedRows: (data) => {
        return { loanDrawIds: data.map(d => d.id), declineReason: changeReason };
      },
    },
    <LmsActionInput value={changeReason} handleChange={setChangeReason} placeHolder="Reason" /> as any
  ];

  const unfundedDrawsEditableColumns = (myForm) => {
    myForm.addCurrencyField("dateDownFee", { inlineEdit: true });
    myForm.addTextareaField("datedownComments", { inlineEdit: true });
    myForm.addCurrencyField("inspectionFee", { inlineEdit: true });
    myForm.addCurrencyField("inspectionSiteVisitFee", { inlineEdit: true });
    myForm.addTextareaField("inspectionComments", { inlineEdit: true });
    myForm.addTextareaField("wireFee", { inlineEdit: true });
    myForm.addTextareaField("drawProcessingFee", { inlineEdit: true });
    return myForm;
  };

  const formatUnfundedDrawsInputs = (inputs, options) => {
    return options.recordsToUpdate.map((input) => {
      const { id, ...updatedColumns } = input;
      return {
        id,
        ...options.filteredData?.find((row) => row.id === id) || {},
        ...updatedColumns
      };
    });
  };

  return <LmsTable
    actionButtons={actionButtons}
    calculatedColumns={[
      "budgetDrawAmount",
      "dateDownFee",
      "inspectionFee",
      "inspectionSiteVisitFee",
      "wireFee",
      "totalDrawAmt",
      "fundWireAmt",
      "lpwireAmt"
    ]}
    apiSuffix="draws/unfunded-draws"
    columnClickOptions={{
      drawMgmt: { downloadPath: "draws/export-histories?loanId={id}", idProp: "loanId" },
    }}
    columnLabelsDictionary={{
      loanNumber: "Loan #",
      bcp: "BCP",
      lpwireAmt: "LP Wire Amt",
      wireCheck: "Payment Type",
      wireCheckCreated: "Payment Created"
    }}
    saveSuffix="draws/unfunded-draws"
    saveMethod="PUT"
    saveFormattingFunction={formatUnfundedDrawsInputs}
    myForm={unfundedDrawsEditableColumns(new BCFormController())}
  />;
};

export default LmsAccountingUnFundedDraws;